<span class="badge badge--{{ badge.type }}">{{ badge.name }}</span>